// extracted by mini-css-extract-plugin
export default {"rgpd":"RGPD_rgpd__NTLZF","title":"RGPD_title__dm9tN"};